import Register from "../../container/auth/register";

export default Register;
